// extracted by mini-css-extract-plugin
export default {"container":"QRCodeCategory_container__PKIyO","qr":"QRCodeCategory_qr__9BnlT"};